import { render, staticRenderFns } from "./0015.vue?vue&type=template&id=0e96858d&scoped=true&"
import script from "./0015.vue?vue&type=script&lang=js&"
export * from "./0015.vue?vue&type=script&lang=js&"
import style0 from "./0015.vue?vue&type=style&index=0&id=0e96858d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96858d",
  null
  
)

export default component.exports